import React from 'react'
import { TableRow as DefaultTableRow } from '../../../shared/components/ui/table'
import { cn } from '../../../shared/lib/utils'

const TableRow = React.forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(({ className, ...props }, ref) => (
    <DefaultTableRow
        ref={ref}
        className={cn("border-b-0", className)}
        {...props}
    />
))
TableRow.displayName = "TableRow"

export default TableRow
